/**
 * Picks the one decision for a settled map position.
 *
 * Policies are evaluated in registration order and the first non-null decision
 * wins. When no policy applies, the neutral fallback leaves focused mode if it was
 * active and otherwise does nothing; it never changes the location type, so
 * removing any policy from the list leaves a defined state.
 *
 * @module searchResultsMap/services/decideViewportSearch
 */

import { exitFocused, none } from './decisions';
import ViewportSearchMode from '../enums/viewportSearchMode';

function getFallbackDecision(snapshot) {
  if (snapshot.mode === ViewportSearchMode.Focused) {
    return exitFocused();
  }

  return none();
}

/**
 * @param {Array<{ evaluate: (snapshot: object) => object|null }>} policies
 * @param {Readonly<object>} snapshot
 * @returns {Readonly<object>} The winning decision, or the fallback.
 */
export default function decideViewportSearch(policies, snapshot) {
  const orderedPolicies = Array.isArray(policies) ? policies : [];

  // `??` short-circuits, so policies after the winner are never evaluated.
  const decision = orderedPolicies.reduce(
    (winner, policy) => winner ?? policy?.evaluate?.(snapshot) ?? null,
    null,
  );

  return decision ?? getFallbackDecision(snapshot);
}
